<template>
  <div class="container pull-up">
    <div class="row">
      <div class="col-md-12">
        <el-card class="box-card text-center">
          <div slot="header" class="clearfix">
            <h3>{{ $t('report.supply.name') }}</h3>
          </div>
          <el-form :inline="true" :model="form" class="demo-form-inline">
            <el-form-item label="Start">
              <el-date-picker v-model="form.start_date" format="dd MMM, yyyy"
                              value-format="yyyy-MM-dd"
                              placeholder="Select a start date"></el-date-picker>
            </el-form-item>
            <el-form-item label="End">
              <el-date-picker v-model="form.end_date" format="dd MMM, yyyy"
                              value-format="yyyy-MM-dd"
                              placeholder="Select an end date"></el-date-picker>
            </el-form-item>
            <el-form-item label="Supplier">
              <el-select collapse-tags multiple v-model="form.supplier" placeholder="Choose supplier">
                <el-option v-for="(sup, ind) in suppliers" :key="ind" :label="sup.name"
                           :value="sup.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Items">
              <el-select clearable collapse-tags multiple v-model="form.items" placeholder="Select item(s)">
                <el-option v-for="(item, ind) in items" :key="item.id" :label="item.name"
                           :value="item.id">
                  <span style="float: left">{{ item.code }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.name }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="">
              <el-checkbox v-model="form.dl">Download</el-checkbox>
            </el-form-item>
            <el-form-item>
              <el-button :loading="loading" type="primary" @click="onReportSubmit">Query</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </div>
    </div>
    <br>
    <el-row>
      <el-card class="box-card">
        <el-table
          :data="supplies"
          style="width: 100%" show-summary :summary-method="getSummaries">
          <el-table-column
            prop="supplier.name"
            label="Supplier"
            width="180">
          </el-table-column>
          <el-table-column
            label="Items"
            width="180">
            <template slot-scope="scope">
              <span v-html="getItemNames(scope.row)"></span>
            </template>
          </el-table-column>
          <el-table-column
            prop="total_cost"
            label="Total">
            <template slot-scope="scope">
              <span class="currency">{{ scope.row.total_cost | currency }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="paid"
            label="Paid">
            <template slot-scope="scope">
              <span class="currency">{{ scope.row.paid | currency }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="owed"
            label="Owed">
            <template slot-scope="scope">
              <span class="currency">{{ scope.row.owed | currency }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="date"
            label="Date" :formatter="$shortDate">
          </el-table-column>
        </el-table>
      </el-card>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'Supplies',
  data () {
    return {
      form: {
        start_date: null,
        end_date: null,
        supplier: null,
        item: [],
        dl: false
      },
      suppliers: [],
      items: [],
      supplies: [],
      loading: false
    }
  },
  methods: {
    getSummaries (param) {
      const {
        columns,
        data
      } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = this.$t('title.totals')
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          sums[index] = this.formatPrice(sums[index])
        } else {
          sums[index] = ''
        }
      })
      return sums
    },
    getItemNames (row) {
      return (row.items.map((item) => item.item.name + `(<span class="currency">${item.quantity}</span>)`).join(', '))
    },
    onReportSubmit () {
      const query = Object.assign({}, this.form)
      if (!query.dl) delete query.dl
      this.loading = true
      this.$reportService.getSupplies(query)
        .then(data => {
          this.supplies = data.data
          if (this.form.dl && data.url) {
            this.$electron.shell.openExternal(data.url, {}, (err) => {
              if (err) {
                this.displayMessage(err, () => {
                }, 'error')
                return false
              }
              this.displayMessage(this.$t('report.message.downloaded'))
            })
            /* ipcMain.on('download', (event, info) => {
                console.log('Initiating download...', info)
                download(BrowserWindow.getFocusedWindow(), info.url, info.properties)
                  .then(dl => this.$electron.mainWindow.webContents.send('download complete', dl.getSavePath()))
              })
              this.$electron.ipcRenderer.send('download', {
                url: data.url,
                properties: {directory: 'C:/Users/Matt-Klaus/Download'}
              }) */
          }
        })
        .catch(error => {
          this.displayMessage(error.message, () => {
          }, 'error')
        })
        .then(() => {
          this.loading = false
        })
    },
    downloadFile (url) {
    },
    showProgress (received, total) {
      const percentage = (received * 100) / total
      console.log(percentage + '% | ' + received + ' bytes out of ' + total + ' bytes.')
    },
    async fetchSuppliers () {
      try {
        await this.withLoading(async () => {
          this.suppliers = await this.$supplierService.getSuppliers()
        }, 'loading')
      } catch (error) {
        // Error is already handled by the global interceptor
        console.log('Component caught error in getSuppliers:', error)
      }
    },
    async fetchItems () {
      try {
        await this.withLoading(async () => {
          this.items = await this.$itemService.getItems()
        }, 'loading')
      } catch (error) {
        // Error is already handled by the global interceptor
        console.log('Component caught error in fetchItems:', error)
      }
    }
  },
  async mounted () {
    this.$emit('parent-title', this.$t('report.supply.name'))
    await this.fetchSuppliers()
    await this.fetchItems()
  }
}
</script>

<style scoped>

</style>
